var _path, _path2, _path3, _path4, _g, _path5, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAgent({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 58,
    viewBox: "0 0 63 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4996 5.64706C19.0876 5.64706 15.511 8.93592 15.511 12.9926C15.511 17.0494 19.0876 20.3382 23.4996 20.3382C27.9117 20.3382 31.4883 17.0494 31.4883 12.9926C31.4883 8.93592 27.9117 5.64706 23.4996 5.64706ZM10.1854 12.9926C10.1854 6.23111 16.1464 0.75 23.4996 0.75C30.8529 0.75 36.8143 6.23111 36.8143 12.9926C36.8143 19.7542 30.8529 25.2353 23.4996 25.2353C16.1464 25.2353 10.1854 19.7542 10.1854 12.9926ZM17.9769 30.6341C18.5322 31.8862 17.8783 33.3151 16.5167 33.8257C10.3485 36.1388 6.19105 41.3499 6.19105 47.2717C6.19105 48.6243 4.99864 49.7203 3.52806 49.7203C2.05747 49.7203 0.865234 48.6243 0.865234 47.2717C0.865234 39.1374 6.56643 32.2681 14.5056 29.2914C15.8672 28.7808 17.4216 29.3818 17.9769 30.6341Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2713_26436",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 24,
    width: 40,
    height: 34
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.291 57.5213L62.4011 25.012L23.2471 24.8999L23.137 57.4091L62.291 57.5213Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2713_26436)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0657 45.7344L53.657 47.0912C52.997 47.2568 52.6667 47.3394 52.3966 47.5039C52.1578 47.6495 51.9536 47.8408 51.7979 48.0654C51.622 48.3191 51.5318 48.6296 51.3522 49.2512L49.8799 54.3438L48.4423 49.2427C48.2667 48.6204 48.179 48.309 48.0047 48.0543C47.8503 47.8291 47.6478 47.6365 47.4097 47.4895C47.1406 47.3237 46.8113 47.2388 46.1524 47.0697L40.7531 45.6819L46.1618 44.3251C46.8217 44.1595 47.1517 44.0766 47.4218 43.9121C47.661 43.7665 47.8648 43.5755 48.0205 43.3509C48.1968 43.0972 48.2866 42.7864 48.4662 42.1651L49.9385 37.0725L51.3764 42.1733C51.5517 42.7959 51.6395 43.107 51.8137 43.3616C51.9681 43.5872 52.1709 43.7795 52.4087 43.9264C52.6778 44.0926 53.0075 44.1772 53.6661 44.3466L59.0657 45.7344Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2713_26436",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 42,
    width: 13,
    height: 12
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8589 53.0585L38.895 42.3816L26.1882 42.3452L26.1521 53.0221L38.8589 53.0585Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2713_26436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.2882 47.7148L34.4738 48.3429C34.1304 48.4197 33.9585 48.4579 33.8182 48.5343C33.6938 48.6015 33.5875 48.6903 33.5064 48.7944C33.4149 48.912 33.3682 49.056 33.275 49.3439L32.5098 51.7049L31.7603 49.3397C31.6692 49.0511 31.6235 48.9068 31.5326 48.7886C31.4522 48.6841 31.3466 48.595 31.2228 48.5267C31.0829 48.4497 30.9114 48.4105 30.5683 48.3318L27.7583 47.6874L30.5727 47.0593C30.9161 46.9825 31.088 46.9443 31.2282 46.8679C31.3527 46.8007 31.459 46.7119 31.54 46.6077C31.6315 46.4902 31.6783 46.3462 31.7715 46.0583L32.5367 43.6973L33.2861 46.0625C33.3776 46.3511 33.4233 46.4954 33.5138 46.6136C33.5942 46.7181 33.6998 46.8072 33.8236 46.8755C33.9639 46.9525 34.1351 46.9917 34.4782 47.0704L37.2882 47.7148Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2713_26436",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 27,
    width: 19,
    height: 16
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8649 42.4048L47.9149 27.6456L29.9759 27.5943L29.926 42.3535L47.8649 42.4048Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2713_26436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.6479 35.02L41.6747 35.8881C41.1897 35.9938 40.9472 36.0471 40.7491 36.1522C40.5735 36.2456 40.4235 36.368 40.3091 36.512C40.1799 36.6745 40.114 36.8737 39.9822 37.2716L38.9021 40.5354L37.8442 37.2658C37.7151 36.8668 37.6505 36.667 37.5223 36.5038C37.409 36.3595 37.26 36.2361 37.0851 36.1417C36.8873 36.0353 36.6451 35.9811 36.1611 35.8724L32.1937 34.9815L36.1671 34.113C36.6518 34.0073 36.8943 33.9544 37.0928 33.8489C37.2684 33.7556 37.4181 33.6331 37.5324 33.4895C37.6619 33.3269 37.7279 33.1278 37.8594 32.7295L38.9394 29.4661L39.9976 32.7357C40.1265 33.1346 40.191 33.3341 40.3192 33.4973C40.4329 33.642 40.5819 33.7654 40.7568 33.8594C40.9543 33.9658 41.1964 34.0203 41.6805 34.129L45.6479 35.02Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAgent);
export default __webpack_public_path__ + "static/media/icon-agent.6a8a572136acfa92b92bb8502614189d.svg";
export { ForwardRef as ReactComponent };